import get from 'lodash/get';
import pickBy from 'lodash/pickBy'
import * as modes from '~/modules/modal/modes';
import getStorageValue from '~/misc/getStorageValue';
import safeJSONParse from '~/misc/safeJSONParse';

const isLeavingPath = (oldPath, newPath, path) =>
  oldPath && oldPath.startsWith(path) && (!newPath || !newPath.startsWith(path));

import A from './types';
import modalTypes from '~/modules/modal/types';

const initialSetAlert = () => {
  if(!localStorage.getItem("isSetAlert")) {
    localStorage.setItem("isSetAlert", "true");
    localStorage.setItem("isSetAlertPoped", "false")
  }
}

const booleanString = (string) => {
  return string === "true";
}

const booleanFalseString = (string) => {
  return string === "false";
}

const init = () => {
  const jobName = getStorageValue('jobName');
  const jobNameDesc = getStorageValue('jobNameDesc');
  const userTrackingProps = safeJSONParse(getStorageValue('ajs_user_traits'));

  initialSetAlert();
  return {
    id: null,
    token: getStorageValue('sessionToken'),
    jobName: jobName || (userTrackingProps && userTrackingProps.jobName),
    jobNameDesc,
    jobTitleReported: safeJSONParse(getStorageValue('jobTitleReported')) || Boolean(jobName),
    isSetAlert: booleanString(getStorageValue('isSetAlert')),
    isSetAlertPoped: booleanString(getStorageValue('isSetAlertPoped'))
  };
};

const getErrorsCleaner = (leavingLogin, leavingSignup, leavingForgot) => (state, action, fullState) => {
  if (state.loginError && leavingLogin(action, fullState)) {
    return {
      loginError: null,
    };
  }

  if (state.signUpErrorMessage && leavingSignup(action, fullState)) {
    return {
      signUpErrorMessage: null,
    };
  }

  if (state.resetPasswordErrorMessage && leavingForgot(action, fullState)) {
    return {
      resetPasswordErrorMessage: null,
    };
  }

  return null;
};

const getModeChangeChecker = (url) => (action, fullState) =>
  isLeavingPath(fullState.modal.uri, action.payload.uri, url);

const getModeCloseChecker = (url) => (action, fullState) =>
  isLeavingPath(fullState.modal.uri, '', url);

const modesToCheck = [modes.LOGIN, modes.SIGNUP, modes.RESET_PASSWORD];

const cleanOnModeChange = getErrorsCleaner(
  ...modesToCheck.map(getModeChangeChecker)
);

const cleanOnModeClose = getErrorsCleaner(
  ...modesToCheck.map(getModeCloseChecker)
);

const getUserData = (payload) => ({
  firstName: get(payload, 'first_name', null),
  lastName: get(payload, 'last_name', null),
  email: get(payload, 'email', null),

  dot_verified: get(payload, 'dot_verified', null),
  mc_verified: get(payload, 'mc_verified', null),

  mc: get(payload, 'mc', null),
  dot: get(payload, 'dot', null),

  phone: get(payload, 'phone.number', null),
  phone_ext: get(payload, 'phone.ext', null),
  ext: get(payload, 'phone.ext', null),
  verified_phone: get(payload, 'phoneCheck', null),

  id: get(payload, 'id', null),
  companyName: get(payload, 'company.name', null),
  createdAt: get(payload, 'created_at', null),

  identity: get(payload, 'identity', null),
  emailVerified: get(payload, 'emailVerified', null),
  company: get(payload, 'company.name', null),
  authority: get(payload, 'authority', null),
  insuranceType: get(payload, 'insuranceType', null),
  legalName:  get(payload, 'legalName', null),
  premiumInfo:get(payload, 'premium_info', null),
  verify_result: get(payload, 'verify_result', null),
  w9form: get(payload, 'w9form', null),
  profileVerificate:get(payload, 'profileVerificate', null), 
  isL2User: get(payload, 'profileVerificate.w9formStatus', null) === "Verified",
  infoIsComplete: get(payload, 'first_name', null)
    && get(payload, 'last_name', null)
    && (get(payload, 'mc', null) || get(payload, 'dot', null))
    && get(payload, 'phone.number', null)
    && get(payload, 'verify_result', null),
});

const updateUserData = (payload,state) => {
  return pickBy(getUserData(payload), e=>!!e)
}

const reducer = (state, action, fullState) => {
  switch (action.type) {
    case A.USER_REPORTED_JOBTILE: {
      return {
        jobTitleReported: true,
        jobName: action.payload.title,
        jobNameDesc: action.payload.desc,
      };
    }
    case A.LOGIN:
      if (action.pending) {
        return {
          loading: true,
        };
      }
      if (action.error) {
        return {
          loading: false,
          isLoggedIn: false,
          loginPending: false,
          loginError: action.payload.message,
        };
      }
      return {
        loading: false,
        isLoggedIn: true,
        signUpErrorMessage: null,
        loginPending: false,
        loginError: null,
        token: action.payload.token,
      };
    case A.SET_TOKEN: {
      return {
        loading: false,
        isLoggedIn: true,
        signUpErrorMessage: null,
        loginPending: false,
        loginError: null,
        token: action.payload.token,
      };
    }
    case A.USER_UPDATED: {
      if (action.pending || action.error) {
        return null;
      }

      return {
        ...state,
        ...getUserData(action.payload),
      };
    }
    case A.USER_DATA: {
      if (action.pending) {
        return {
          loading: true,
        };
      }
      if (action.error) {
        return {
          loading: false,
          isLoggedIn: false,
          token: get(action, 'payload.message') === 'token_invalid' ? null : state.token,
        };
      }
      return {
        loading: false,
        isLoggedIn: true,
        signUpErrorMessage: null,
        loginPending: false,
        loginError: null,
        ...getUserData(action.payload),
      };
    }
    case A.USER_VERIFY: {
      if (action.pending){
        return {
          ...state,
          loading: true,
        };
      }
      return {
        ...state,
        loading: false,
        ...updateUserData(action.payload.data,state),
      };
    }
    case A.USER_W9FORM: {
      if (action.pending){
        return {
          ...state,
          loading: true,
        };
      }
      return {
        ...state,
        loading: false,
        ...updateUserData(action.payload.data,state),
      };
    }
    case A.LOGOUT: {
      return {
        isLoggedIn: false,
        token: null,
        ...getUserData(action.payload),
      };
    }
    case A.SIGNUP: {
      if (action.pending) {
        return {
          loading: true,
        };
      }
      if (action.error) {
        return {
          loading: false,
          signUpErrorMessage: action.payload.message,
        };
      }
      return {
        loading: false,
        token: action.payload.token,
        signUpErrorMessage: null,
      };
    }
    case A.SIGNUPV2: {
      if (action.pending) {
        return {
          loading: true,
        };
      }
      //NOTICE: here maybe cause confusion
      // Because promiseAction return failAction,it use action.error.
      // but frontEnd check use failActionButPassMetrics,it use action.isError for some reason.
      // see more detail in dispatch.js:failActionButPassMetrics
      // TODO: should be reforactored
      if (action.isError) {
        return {
          loading: false,
          signUpErrorMessage: action.payload.message,
        };
      }
      if (action.error) {
        return {
          loading: false,
          signUpErrorMessage: action.payload.message,
        };
      }
      return {
        loading: false,
        token: action.payload.token,
        signUpErrorMessage: null,
      };
    }
    case A.RESET_PASSWORD: {
      if (action.pending) {
        return {
          resetPasswordErrorMessage: null,
          resettingPassword: true,
        };
      }

      if (action.error) {
        return {
          resetPasswordErrorMessage: action.payload.message,
          resettingPassword: false,
        };
      }

      return {
        resetPasswordErrorMessage: null,
        resettingPassword: false,
      };
    }

    case A.CHANGE_PASSWORD: {
      if (action.pending) {
        return {
          changePasswordErrorMessage: null,
          changingPassword: true,
        };
      }

      if (action.error) {
        return {
          changePasswordErrorMessage: action.payload.message,
          changingPassword: false,
        };
      }

      return {
        changePasswordErrorMessage: 'Success!',
        changingPassword: false,
      };
    }

    case A.CHANGE_PASSWORD_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        changePasswordErrorMessage: null,
      };
    }

    case A.USER_RESET_ERROR: {
      switch (action.payload) {
        case 'login':
          return {
            loginError: null,
          };
        case 'signup':
          return {
            signUpErrorMessage: null,
          };
        case 'passwordReset':
          return {
            resetPasswordErrorMessage: null,
          };
      }
      break;
    }

    case A.USER_SET_ALERT: {
      return {
        ...state,
        isSetAlert: action.payload
      }
    }

    case A.USER_SET_ALERT_POP: {
      return {
        ...state,
        isSetAlertPoped: true,
      }
    }

    case A.USER_SET_ALERT_DEFLUAT: {
      if (action.pending || action.error) {
        return {
          ...state
        }
      }
      const { is_select_carrier_search,  is_carrier_popup_window} = action.payload.data;
      return {
        ...state,
        isSetAlert: is_select_carrier_search,
        isSetAlertPoped: is_carrier_popup_window,
      }
    }

    case modalTypes.MODAL_URI_CHANGED: {
      return cleanOnModeChange(state, action, fullState);
    }

    case modalTypes.MODAL_URI_CLOSED: {
      return cleanOnModeClose(state, action, fullState);
    }
  }

  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/user/reducer.js